import type * as FormModelType from "@/components/features/settings/payment-deposit-account/model/type";
import type * as QueryRepository from "@/components/features/settings/payment-deposit-account/repository/query";

export const serverModelToInputModelConverter = (serverModel: QueryRepository.ServerModel) => {
	return {
		hotelID: serverModel?.hotelID ?? "",
		minimumTransferAmount: serverModel?.minimumTransferAmount ?? 0,
		bankCode: serverModel?.bankCode ?? "",
		bankBranchCode: serverModel?.bankBranchCode ?? "",
		bankAccountType: serverModel?.bankAccountType ?? "普通",
		bankAccountNumber: serverModel?.bankAccountNumber ?? "",
		bankAccountHolderName: serverModel?.bankAccountHolderName ?? "",
	} satisfies FormModelType.PaymentDepositAccountFormModel["InputModel"];
};
